import { render, staticRenderFns } from "./stat.vue?vue&type=template&id=42118e39&scoped=true"
import script from "./stat.vue?vue&type=script&lang=ts"
export * from "./stat.vue?vue&type=script&lang=ts"
import style0 from "./stat.vue?vue&type=style&index=0&id=42118e39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42118e39",
  null
  
)

export default component.exports